import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { AttendancePlace } from '../../_models/attendance-place';
import { AttendancePlaceService } from '../../_services/attendance-place.service';
import { ContractService } from '../../_services/contract.service';
import { ReportService } from '../../_services/report.service';
import { RouteService } from '../../_services/route.service';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-attendance-general',
  templateUrl: './attendance-general.component.html',
  styleUrls: ['./attendance-general.component.css']
})
export class AttendanceGeneralComponent implements OnInit {
  attendanceList: any[];
  attendancePlaceList: any[];
  searchForm: FormGroup;
  loading = false;
  submitted = false;
  error = '';
  page = 1;
  totalResults = 0;
  resultsPerPage = 0;
  loadingExport = false;
  statusList: any[];
  contractStatusList: any[];
  attendanceStatusList: any[];
  routeList: any[];
  date = new Date();

  formatter = (place: AttendancePlace) => place.name;

  constructor(private formBuilder: FormBuilder, private activeRoute: ActivatedRoute, private router: Router, private reportService: ReportService, private attendancePlaceService: AttendancePlaceService, private contractService: ContractService, private routeService: RouteService) { }

  ngOnInit() {

    this.getStatus();
    this.getRoutes();
    this.getContractStatus();

    this.searchForm = this.formBuilder.group({ idRoute: [''], idAttendancePlace: [''], contractStatus: [''], attendanceStatus: [''], month: [this.date.getMonth() + 1, Validators.required], year: [this.date.getFullYear(), Validators.required] });

    this.get(this.page, this.searchForm.controls.idRoute.value, this.searchForm.controls.idAttendancePlace.value, this.searchForm.controls.contractStatus.value, this.searchForm.controls.attendanceStatus.value, this.searchForm.controls.month.value, this.searchForm.controls.year.value)
  }

  onSelectedPage() {
    this.get(this.page, this.searchForm.controls.idRoute.value, this.searchForm.controls.idAttendancePlace.value, this.searchForm.controls.contractStatus.value, this.searchForm.controls.attendanceStatus.value, this.searchForm.controls.month.value, this.searchForm.controls.year.value)
  }

  onSubmit() {
    if (this.searchForm.invalid) {
      return;
    }

    this.page = 1;
    this.get(this.page, this.searchForm.controls.idRoute.value, this.searchForm.controls.idAttendancePlace.value, this.searchForm.controls.contractStatus.value, this.searchForm.controls.attendanceStatus.value, this.searchForm.controls.month.value, this.searchForm.controls.year.value)
  }

  private get(page: number, idRoute: number, attendancePlace: any, contractStatus: number, attendanceStatus: number, month: number, year: number) {
    this.submitted = true;

    this.loading = true;

    var idAttendancePlace = attendancePlace != null ? attendancePlace.id : null;

    this.reportService.getAttendanceGeneral(page, idRoute, idAttendancePlace, contractStatus, attendanceStatus, month, year)
      .subscribe(
        data => {
          this.page = data.pageNumber;
          this.resultsPerPage = data.resultsPerPage;
          this.totalResults = data.totalResults;
          this.attendanceList = data.response;
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        });
  }

  getAttendancePlaces = (text$: Observable<any>) => text$.pipe(
    debounceTime(500),
    distinctUntilChanged(),
    filter(term => term.length >= 3),
    switchMap(term =>
      this.attendancePlaceService.getByArgument(term).pipe(
        catchError(() => {
          return of([]);
        }))
    )
  );

  private getContractStatus() {
    this.contractService.getContractStatus()
      .subscribe(
        data => {
          this.contractStatusList = data;
        },
        error => {
          this.error = error;
        });
  }

  private getStatus() {
    this.attendancePlaceService.getStatus()
      .subscribe(
        data => {
          this.attendanceStatusList = data;
        },
        error => {
          this.error = error;
        });
  }

  private getRoutes() {
    this.routeService.getRoutesActives()
      .subscribe(
        data => {
          this.routeList = data;
        },
        error => {
          this.error = error;
        });
  }

  exportAttendanceGeneral() {

    if (!this.searchForm.controls.month.value) {
      return;
    }

    if (!this.searchForm.controls.year.value) {
      return;
    }

    var idAttendancePlace = this.searchForm.controls.idAttendancePlace.value != null ? this.searchForm.controls.idAttendancePlace.value.id : null;

    this.reportService.exportAttendanceGeneral(this.searchForm.controls.idRoute.value, idAttendancePlace, this.searchForm.controls.contractStatus.value, this.searchForm.controls.attendanceStatus.value, this.searchForm.controls.month.value, this.searchForm.controls.year.value)
      .subscribe(
        data => {
          FileSaver.saveAs(data, 'relatorio-manutencoes.xlsx');
        });
  }
}
